const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/login')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});